// Put your main mutations here
export default {
  updateMarkedRows: (state, payload) => {
    state.process.markedRows = payload;
  },
  increment: (state, payload) => {
    state.counter += payload;
  },
  decrement: (state) => {
    state.counter--;
  },

  auth_request(state) {
    state.status = "loading";
  },

  auth_error(state) {
    state.status = "error";
  },

  auth_success(state, payload) {
    state.status = "success";
    state.token = payload.token;
    state.user.ID_USUARIO = payload.id_user;
    state.user.ID_CLIENTE = payload.id_client;
    state.user.USUARIO = payload.usuario;
    state.user.IMAGE = "img/logos/" + payload.image;
    state.user.MENU = payload.menu_user;
    state.user.ACTIVO = payload.is_active;
    state.user.DETAILS = payload.client_details;
  },

  logout(state) {
    state.status = "";
    state.token = "";
    state.user.ID_USUARIO = "";
    state.user.ID_CLIENTE = "";
    state.user.USUARIO = "";
    state.user.IMAGE = "";
    state.user.MENU = {};
    state.user.ACTIVO = false;
  },

  getCustomers: (state, payload) => {
    state.client_customers = payload;
  }
};
